import { withStyles } from '@material-ui/core';

import Variant from './component';
import styles from './styles';

export default withStyles(styles)(Variant);
